import {css, StyleDeclaration, StyleSheet} from 'aphrodite';
import React from 'react';

import {LEGACY_FONT_PROXIMA_13} from 'styles/FontConstants';
import {miniSpacingRight, SemanticColors} from 'styles/Utilities';
import {GRAY_LIGHTER, WHITE} from 'ui-library/Colors';
import ErrorIcon from 'ui-library/icons/ErrorIcon';

export enum MessageLevel {
  ERROR = 'ERROR',
}

const styles = StyleSheet.create({
  banner: {
    ...LEGACY_FONT_PROXIMA_13,
    overflowWrap: 'break-word',
    padding: '8px 12px',
    textAlign: 'left',
    wordWrap: 'break-word',
  },
  icon: {...miniSpacingRight, float: 'left'},
  error: {color: SemanticColors.dangerColor},
  warning: {},
  informational: {},
});

const LEVEL_SPECIFIC_STYLES: Record<MessageLevel, StyleDeclaration> = {
  [MessageLevel.ERROR]: styles.error,
};

const ICON_COMPONENT_BY_LEVEL: Record<MessageLevel, () => JSX.Element> = {
  [MessageLevel.ERROR]: () => <ErrorIcon />,
};

export enum BannerBackgroundColor {
  WHITE = 'WHITE',
  GRAY_LIGHTER = 'GRAY_LIGHTER',
}

const BANNER_BACKGROUND_TO_COLOR_CODE: {[key in BannerBackgroundColor]: string} = {
  [BannerBackgroundColor.WHITE]: WHITE,
  [BannerBackgroundColor.GRAY_LIGHTER]: GRAY_LIGHTER,
};

export interface BannerProps {
  children: React.ReactNode;
  level: MessageLevel;
  /**
   * Banner background color; set to allow banner to contrast or blend in with different backgrounds.
   * Defaults to light gray.
   */
  backgroundColor?: BannerBackgroundColor;
}

/**
 * A message banner that can be styled at different levels of urgency: Error, Warning, or Informational.
 *
 * @deprecated Please use client/ui-library/banners/InlineBanner instead
 */
export default function Banner(props: BannerProps): JSX.Element {
  const backgroundColor =
    BANNER_BACKGROUND_TO_COLOR_CODE[props.backgroundColor ?? BannerBackgroundColor.GRAY_LIGHTER];

  return (
    <div className={css(styles.banner, LEVEL_SPECIFIC_STYLES[props.level])} style={{backgroundColor}}>
      <span className={css(styles.icon)}>{ICON_COMPONENT_BY_LEVEL[props.level]()}</span>
      {props.children}
    </div>
  );
}
